<template>
  <div class="project-detail" v-if="detail">
    <div class="list">
      <template v-for="(item, i) in detail.items">
        <div class="item hover-border" v-if="item.type === 'image'">
          <img :src="`${options.cdn}/${item.image}`"/>
        </div>
        <div class="item text" v-else-if="item.type === 'text'" v-html="item.content"></div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'project-detail',
    components: {},
    data() {
      return {
        detail: null
      }
    },
    computed: {
      ...mapState(['options'])
    },
    async mounted () {
      const id = this.$route.params.id
      this.detail = await this.axios(`/project/${id}`)
      this.detail.items = JSON.parse(this.detail.items)
    }
  }
</script>

<style lang="stylus" scoped>
  .project-detail
    padding 0 20px

    .list
      column-gap 20px
      column-count 2
      margin 0 auto

      .item
        break-inside avoid
        margin-bottom 20px

        &.text
          padding 5px
          line-height 1.4
          font-family 'NeutraTextTF-BoldAlt'

        img
          width 100%

  @media screen and (max-width: 768px)
    .project-detail
      .list
        column-count 1
</style>
